import { Component } from "@angular/core";

import { AutoUnsubscribeComponent } from "../../../../../app/content/virtual/auto-unsubscribe.component";
import { DevFuncActionInterface } from "../../base/action/dev-func-action.interface";


@Component({
    templateUrl: './policy-pause-action.component.html',
    styleUrls: ['../../base/base-config-form.component.css', '../../dev-func.style.css'],
    standalone: false
})
export class PolicyPauseActionFormComponent extends AutoUnsubscribeComponent implements DevFuncActionInterface {
    readonly POLICY_PAUSE_TIME_MIN: number = 15;
    readonly POLICY_PAUSE_TIME_MAX: number = 1440;

    actionCompleteHandler?: (result: any) => void;
    actionStatusUpdateHandler?: (isValid: boolean) => void;
    actionCommunicateHandler?: (data: any) => void;

    _pauseDuration: number = this.POLICY_PAUSE_TIME_MIN;

    _actionData: any;
    set actionData(data: any) {
        this._actionData = data;
        this._pauseDuration = this._actionData?.pauseDuration
        if (!this._pauseDuration) {
            this._actionData.pauseDuration = this._pauseDuration = this.POLICY_PAUSE_TIME_MIN;
        } 
    }

    changePolicyPauseDuration(value: string): void {
        const v = Number(value);
        this._actionData.pauseDuration = this._pauseDuration = isNaN(v) ? this.POLICY_PAUSE_TIME_MIN : Math.min(Math.max(v, this.POLICY_PAUSE_TIME_MIN), this.POLICY_PAUSE_TIME_MAX); 
    }
}